import { jsx as _jsx } from "react/jsx-runtime";
import clss from 'classnames';
import Icon from '@/components/base/Icon';
import { useCallback, useEffect, useRef } from 'react';
import refreshStore from '@/store/Refresh';
import { isSever, storage } from '@/utils';
import { useThrottleCallback } from '@react-hook/throttle';
function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
var GlobalRefresh = function() {
    var btn = useRef(null);
    var cacheLast = storage.get('refreshLast');
    var start = [
        0,
        0
    ];
    if (!isSever) {
        start = [
            window.innerWidth - 60,
            window.innerHeight - 80
        ];
    }
    if (cacheLast[0] && cacheLast[1]) {
        start = cacheLast;
    }
    var status = null;
    var handleStartMove = function(e) {
        e.stopPropagation();
        e.preventDefault();
        if (btn.current) {
            status = Date.now();
        }
    };
    var handleMove = function(e) {
        if (btn.current && status) {
            var x = e.clientX;
            var y = e.clientY;
            var cy = y - 24;
            var cx = x - 24;
            if (btn.current) {
                btn.current.style.top = cy + 'px';
                btn.current.style.left = cx + 'px';
            }
            start = [
                cx,
                cy
            ];
        }
    };
    var handleEndMove = function(e) {
        e.stopPropagation();
        if (btn.current) {
            storage.set('refreshLast', start);
        }
    };
    var handleRefresh = function() {
        if (!status || Date.now() - status < 300) {
            refreshStore.setRefresh(true);
        }
        status = null;
    };
    var handleSetPosition = useCallback(useThrottleCallback(function(position) {
        if (btn.current) {
            btn.current.style.top = position[1] + 'px';
            btn.current.style.left = position[0] + 'px';
        }
    }), [
        btn
    ]);
    useEffect(function() {
        var resizeFn = function(e) {
            var gap = 120;
            var w = e.currentTarget;
            var cw = w === null || w === void 0 ? void 0 : w.innerWidth;
            var cy = w === null || w === void 0 ? void 0 : w.innerHeight;
            var _start = _slicedToArray(start, 2), x = _start[0], y = _start[1];
            if (cw - gap < x || cw - x > gap) {
                start = [
                    cw - gap,
                    cy - gap
                ];
            }
            handleSetPosition(start);
            storage.set('refreshLast', start);
        };
        if (btn.current) {
            window.addEventListener('resize', resizeFn);
            return function() {
                window.removeEventListener('resize', resizeFn);
            };
        }
    }, [
        btn,
        start,
        handleSetPosition
    ]);
    useEffect(function() {
        window.addEventListener('mouseup', handleEndMove);
        window.addEventListener('mousemove', handleMove);
        handleSetPosition(start);
        return function() {
            window.removeEventListener('mouseup', handleEndMove);
            window.removeEventListener('mousemove', handleMove);
        };
    }, [
        handleEndMove,
        handleMove,
        handleSetPosition,
        start
    ]);
    return(/*#__PURE__*/ _jsx("button", {
        ref: btn,
        className: clss("\n        cursor-pointer h-[48px]\n        top-[9999px]\n        fixed group z-[88] outline-none\n      "),
        onMouseDown: handleStartMove,
        onMouseUp: function(e) {
            return e.preventDefault();
        },
        onClick: handleRefresh,
        children: /*#__PURE__*/ _jsx("div", {
            className: clss("\n          w-[48px] h-[48px] flex items-center justify-center bg-primary rounded-full\n          z-[-10] transition-all duration-500 \n          group-active:scale-110 group-hover:rotate-[360deg]\n        "),
            children: /*#__PURE__*/ _jsx(Icon, {
                className: "text-btn-other text-[24px]",
                type: "refresh-global"
            })
        })
    }));
};
export default GlobalRefresh;
